<template>
  <div class="vehicles-list-actions">
    <former-button
      size="small"
      icon="pen"
      class="vehicles-list-action"
      @click="change"
    >
      Editar veículo
    </former-button>
  </div>
</template>

<script>
  import FormerButton from '@/components/Former/Button.vue';

  export default {
    name: 'VehiclesListItem',
    components: {
      FormerButton,
    },
    props: {
      updateAction: {
        type: String,
        default: '',
      },
      vehicle: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      change() {
        this.$router.push({
          name: this.updateAction,
          params: {
            id: this.vehicle.id,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .vehicles-list-actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .vehicles-list-action {
    & + & {
      margin-left: $gutter-small;
    }
  }
</style>
